'use client';
import { usePathname } from 'next/navigation';
import { useTranslations } from 'next-intl';

export const NotFoundMessage = () => {
  const pathname = usePathname();
  const t = useTranslations('notFound');
  const isTone = pathname.split('/').includes('tones');
  return (
    <p className="text-muted-foreground mb-4">
      {isTone ? t('toneRemoved') : t('pageNotFound')}
    </p>
  );
};

export default NotFoundMessage;
